module.exports = __webpack_public_path__ + "media/illustrations/calendar-0f2b32c6.svg";